// extracted by mini-css-extract-plugin
module.exports = {"chart-type":"ChartType_chart-type__3CQdq","chart-type__icon":"ChartType_chart-type__icon__6IV3k","chart-type_active":"ChartType_chart-type_active__3jlvg"};